import { useEffect } from "react";
import { Link } from "react-router-dom";
import { BookOpenIcon } from "@heroicons/react/24/outline";

import Card from "../../components/shared/Card/Card";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import { helpArticles } from "./helpArticles";

export default function Help() {
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: "Help",
      desc: "Guides for using Wilma day to day",
    });
  }, [setInfo]);

  return (
    <div className="mt-4 space-y-4">
      <Card>
        <div className="p-6">
          <h2 className="text-2xl font-semibold text-slate-900">Help</h2>
          <p className="mt-1 text-sm text-slate-600">
            Guides for yard and office staff. If you still need a hand, raise a support ticket.
          </p>
        </div>
      </Card>

      <div className="grid gap-4 md:grid-cols-2">
        {helpArticles.map((article) => (
          <Link
            key={article.slug}
            to={`/help/${article.slug}`}
            className="block rounded-lg bg-white shadow transition hover:ring-2 hover:ring-primary-200"
          >
            <div className="flex gap-4 p-6">
              <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary-700">
                <BookOpenIcon className="h-6 w-6" aria-hidden="true" />
              </span>
              <div className="min-w-0">
                <h3 className="text-base font-semibold text-slate-900">{article.title}</h3>
                <p className="mt-1 text-sm text-slate-600">{article.description}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
